/**
 * プロンプト履歴 API クライアント (docs/features/prompt-history-db-plan.md)。
 *
 * `GET /api/prompt-history` は本人×現在の組織のプロンプト履歴を DB (usage_logs /
 * scenarios) から集計して返す (localStorage 版とは別の二層目のデータ源)。
 */

import { apiClient } from '../../services/apiClient';
import type { PromptHistoryDbItem } from '../../utils/promptHistoryMerge';

/** localStorage キー (PROMPT_HISTORY_KEYS) に対応する API scope の allowlist */
export type PromptHistoryScope =
  | 'image_prompt'
  | 'image_additional'
  | 'video_prompt'
  | 'scenario_additional'
  | 'actor_generation'
  | 'video_edit_instruction'
  | 'swipe_background_text'
  | 'swipe_background_extra'
  | 'frame_additional';

export interface PromptHistoryResponse {
  items: PromptHistoryDbItem[];
  next_cursor: string | null;
}

export async function fetchPromptHistory(
  scope: PromptHistoryScope,
  params?: { limit?: number; cursor?: string | null; scenarioId?: string | null },
): Promise<PromptHistoryResponse> {
  const queryParams = new URLSearchParams();
  queryParams.append('scope', scope);
  if (params?.limit) queryParams.append('limit', String(params.limit));
  if (params?.cursor) queryParams.append('cursor', params.cursor);
  // シナリオ絞り込み (video_edit_instruction のみ。他 scope では backend が 400 を返す)
  if (params?.scenarioId) queryParams.append('scenario_id', params.scenarioId);

  const response = await apiClient.get<PromptHistoryResponse>(`/prompt-history?${queryParams.toString()}`);
  return {
    items: response.data.items ?? [],
    next_cursor: response.data.next_cursor ?? null,
  };
}
